import React from 'react';
import { AssignProfilePersonModalProps } from './types';
import styles from './AssignProfilePersonModal.module.scss';
import { Button, Card, CardContent, Grid, Modal, Typography } from '@mui/material';
import { useAssignProfilePersonModal } from './useAssignProfilePersonModal';
import ButtonDropDown from '../button-drop-down/ButtonDropDown';
import { useTranslation } from 'react-i18next';
import { USER_PERMISSIONS } from '../constants/permissions';
import { useCheckPermission } from '../hooks/useCheckPermission';

const AssignProfilePersonModal = ({
  onClose,
  primaryAction,
  open,
  modalMessage,
  actionButtonText,
  actionButtonTextSecondary,
  goBackButtonText,
  secondaryAction,
  document,
  assignee,
  setAssignee,
  category,
  modalTitle,
  headerVariant,
}: AssignProfilePersonModalProps) => {
  const {
    selectedSupplier,
    setSelectedSupplier,
    getProfileNames,
    getSupplierOptions,
    getSupplierContactOptions,
    checkProfilePersonsAvailability,
  } = useAssignProfilePersonModal(category, document);
  const checkPermission = useCheckPermission();
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose} closeAfterTransition className='action-modal'>
      <Grid container className={styles.modal_container}>
        <Grid size={{ xs: 11, md: 6, lg: 5 }}>
          <Card>
            <CardContent sx={{ paddingBottom: '16px !important' }}>
              {modalTitle && (
                <Typography variant={headerVariant ? headerVariant : 'h6'} gutterBottom>
                  {modalTitle}
                </Typography>
              )}
              {document.customers.length === 0 &&
                document.employees.length === 0 &&
                document.suppliers.length === 0 &&
                checkProfilePersonsAvailability(document.category) && (
                  <>
                    {modalMessage && <Typography>{modalMessage}</Typography>}
                    {category === 'suppliers' ? (
                      <>
                        <Grid container spacing={2}>
                          <Grid flexGrow={1} width={'50%'} marginTop={'16px'}>
                            <ButtonDropDown
                              label={t('labels.selectSupplier')}
                              value={selectedSupplier}
                              onChange={(event) => setSelectedSupplier(event.target.value)}
                              options={getSupplierOptions()}
                              placeholder={t('labels.chooseSupplier')}
                              disabled={
                                !category ||
                                getSupplierOptions().length === 0 ||
                                !checkPermission(
                                  USER_PERMISSIONS.ORG_DOCUMENT_UPLOAD_ASSIGN_PROFILE
                                )
                              }
                            />
                          </Grid>
                          <Grid flexGrow={1} width={'50%'} marginTop={'16px'}>
                            <ButtonDropDown
                              label={t('labels.assignTo')}
                              value={assignee}
                              onChange={(event) => setAssignee(event.target.value)}
                              options={getSupplierContactOptions(selectedSupplier)}
                              placeholder={t('labels.assignTo')}
                            />
                          </Grid>
                        </Grid>
                      </>
                    ) : (
                      <Grid flexGrow={1} width={'50%'} marginTop={'16px'}>
                        <ButtonDropDown
                          label={t('labels.assignTo')}
                          value={assignee}
                          onChange={(event) => setAssignee(event.target.value)}
                          options={getProfileNames()}
                          placeholder={t('labels.chooseAssignee')}
                          disabled={!category || getProfileNames().length === 0}
                        />
                      </Grid>
                    )}
                  </>
                )}
              <Grid container justifyContent='flex-end' gap={'8px'} mt={2}>
                <Button
                  variant='contained'
                  onClick={onClose}
                  className={'btn-default btn-action-basic btn-cancel'}
                >
                  {goBackButtonText}
                </Button>
                <Button
                  variant='contained'
                  onClick={secondaryAction}
                  className='btn-default btn-action-basic'
                >
                  {actionButtonTextSecondary}
                </Button>
                {'document_upload_html' in document && document.document_upload_html.length > 0 && (
                  <Button
                    variant='contained'
                    onClick={primaryAction}
                    className='btn-default btn-action-basic'
                  >
                    {actionButtonText}
                  </Button>
                )}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Modal>
  );
};

export { AssignProfilePersonModal };
